import { gql } from "@apollo/client";

export const AssetLocationImportWidget = gql`
    query AssetLocationImportWidget ($id: ID!) {
        assetLocation (id: $id) {
            id
            asset {
                id
                assetLocationImport {
                    id
                    insert
                    status
                }
            }
        }
    }
`;
